import axios from 'axios';
export class AppAdminService {
    config;
    auth;
    baseURL = '';
    constructor(auth, config) {
        this.config = config;
        this.auth = auth;
        this.baseURL = this.config.API.baseApiUrl;
    }
    headers() {
        if (!this.auth.currentAppAdmin)
            throw new Error('The current user is not an app admin');
        return {
            Authorization: `Bearer ${this.auth.currentAppAdmin?.token}`,
        };
    }
    profile = {
        updateSelf: async (payload) => {
            const res = await axios.put(`${this.baseURL}/profile/app-admin/self/authority`, payload, {
                headers: this.headers(),
            });
            return res.data;
        },
    };
    hauler = {
        query: async () => {
            const res = await axios.get(`${this.baseURL}/hauler/app-admin`, {
                headers: this.headers(),
            });
            return res.data;
        },
    };
}
//# sourceMappingURL=app-admin.service.js.map